// src/components/select/LiquidacionSelect.jsx
import React, { useEffect, useRef, useState } from "react";
import apiRoutes from "../../api/apiRoutes";
import { apiFetchJson } from "../../utils/http";

export default function LiquidacionSelect({
  value,
  onChange,
  disabled = false,
  autoLoad = false, // 👈 permite precargar al montar
}) {
  const boxRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);

  // =========================
  // CERRAR CLICK FUERA
  // =========================
  useEffect(() => {
    const outside = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", outside);
    return () => document.removeEventListener("mousedown", outside);
  }, []);

  // =========================
  // FETCH
  // =========================
  const load = async (pageToLoad = 0, reset = false) => {
    setLoading(true);
    try {
      const data = await apiFetchJson(
        apiRoutes.liquidacion.autocomplete({
          page: pageToLoad,
          size: 20,
        })
      );

      const mapped = (data.items || []).map((it) => ({
        id: it.id,
        label: it.descripcion,
      }));

      setItems((prev) => (reset ? mapped : [...prev, ...mapped]));
      setHasMore(data.hasMore === true);
      setPage(pageToLoad);
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // PRECARGA AL MONTAR
  // =========================
  useEffect(() => {
    if (autoLoad && items.length === 0 && !loading) {
      load(0, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoLoad]);

  // =========================
  // ABRIR
  // =========================
  const openDropdown = () => {
    if (disabled) return;
    setOpen(true);

    // 🔒 solo carga si todavía no hay datos
    if (items.length === 0) {
      load(0, true);
    }
  };

  return (
    <div ref={boxRef} className="relative">
      {/* INPUT SIMULADO */}
      <div
        className={`input flex items-center ${
          disabled ? "opacity-60" : "cursor-pointer"
        }`}
        style={{ minHeight: 42 }}
        onClick={openDropdown}
      >
        {value ? (
          <span>{value.label}</span>
        ) : (
          <span className="text-gray-400">
            -- Seleccionar liquidación --
          </span>
        )}
      </div>

      {/* DROPDOWN */}
      {open && (
        <div className="absolute z-30 mt-1 w-full bg-white border rounded shadow max-h-64 overflow-auto">
          {/* opción vacía */}
          <div
            className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-gray-600"
            onClick={() => {
              onChange?.(null);
              setOpen(false);
            }}
          >
            -- Seleccionar --
          </div>

          {items.map((it) => (
            <div
              key={it.id}
              className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                onChange?.(it);
                setOpen(false);
              }}
            >
              {it.label}
            </div>
          ))}

          {hasMore && (
            <button
              type="button"
              className="w-full text-sm py-2 text-blue-600 hover:bg-gray-50"
              disabled={loading}
              onClick={() => load(page + 1)}
            >
              {loading ? "Cargando…" : "Cargar más"}
            </button>
          )}

          {!loading && items.length === 0 && (
            <div className="px-3 py-2 text-gray-400">
              Sin resultados
            </div>
          )}
        </div>
      )}
    </div>
  );
}
